import * as amap from './amap'
import * as baiduHM from './baiduHM'
import * as element from './element'
import * as joywok from './joywok'
import * as googleTag from './googleTag'
import * as vant from './vant'
import * as userTracking from './userTracking'
import * as mobileFlexible from './mobileFlexible'

export default {
  amap,
  baiduHM,
  element,
  joywok,
  googleTag,
  vant,
  userTracking,
  mobileFlexible
}
